import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { times } from '@primeicons/core/times';

@Component({
    selector: 'svg[data-p-icon="times"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class Times extends CoreIcon {
    constructor() {
        super();
        this._icon = times;
    }
}
